import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerInitiatePaymentApiCallSuccess, triggerTxnStatusApiCall } from 'redux/actions';
import { TRIGGER_INITIATE_PAYMENT_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerInitiatePaymentApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const TXN_ID = data['txnId'];
	const PATH = data['path'];
	let url = API_CONSTANT.URL.INITIATE_PAYMENT;
	url = TXN_ID ? API_CONSTANT.URL.INITIATE_PAYMENT + API_CONSTANT.QUERY_PARAMS.TXN_ID + TXN_ID : url;
	if (data?.originalTxnId) {
		data['txnId'] = data['originalTxnId'];
		delete data['originalTxnId'];
	}
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url,
		data,
		method: TXN_ID ? 'GET' : 'POST',
		options: {
			defaultLoader: !stopLoader,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			callback && callback(apiData);
			yield put(triggerInitiatePaymentApiCallSuccess(apiData));
			localStorage.setItem('txn', 'true');
			yield put(
				triggerTxnStatusApiCall({
					txnId: apiData?.['txnId'],
					path: PATH,
				}),
			);
		}
	}
}

export default function* triggerInitiatePaymentApiCallSaga() {
	yield takeEvery(TRIGGER_INITIATE_PAYMENT_API_CALL, triggerInitiatePaymentApiCall);
}
